import { Pipe, PipeTransform } from '@angular/core';
import { Multiple } from '../Model/Multiple';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'multipleFilter',
  standalone: false
})
export class MultipleFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(multiplesList: Multiple[], searchTerm: string, field?: string): Multiple[] {
    if (!multiplesList || !searchTerm?.trim()) {
      return multiplesList;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return multiplesList.filter(item => {
      if (field && item[field] != null) {
        const value = this.formatValue(item[field], field);
        return value.includes(lowerSearch);
      }

      const defaultFields = [
        'marketCompanyName',
        'multiplesCategoryCode',
        'multiplesCategoryLabel',
        'LastUpdateDate',
        'applicationDate',
        'UserName'
      ];

      return defaultFields.some(key => {
        const value = this.formatValue(item[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';

    if (['LastUpdateDate', 'applicationDate'].includes(field)) {
      const formatted = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formatted ? formatted.toLowerCase() : '';
    }

    return value.toString().toLowerCase();
  }
}
